import { RootStateOrAny, useSelector } from 'react-redux';

import { hasOnlyMembershipCartItem as hasOnlyMembershipCartItemSelector } from '../../utils/selectors';

// to show progress bar always once cart is loaded for smooth transitioning
// between progress states once item is added/removed
export function useHideProgressBar() {
  const { itemCount } = useSelector(({ checkout }: RootStateOrAny) => checkout);
  const hasOnlyMembershipItem = useSelector(hasOnlyMembershipCartItemSelector);
  const hasNoItems = itemCount < 1;
  const cartIsEmpty = hasNoItems || hasOnlyMembershipItem;

  return cartIsEmpty;
}
